
import React, { useState, useEffect } from "react";
import sendRequest from "../utils/sendRequest";
import validators from "../utils/validators";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import TextField, { textFieldClasses } from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Navbar from "../components/Navbar";
import swal from "sweetalert";
import Loader from "../components/Loader";
import { checkAuth } from "../utils/checkAuth";
import { Autocomplete, Checkbox, ListItemText } from "@mui/material";
import EmailResetModal from "./EmailResetModal";
import SecureLS from "secure-ls";


const domains = {
    SEBIUSER: "sebi.gov.in",
    KFIN: "kfintech.com",
    CAMS: "cams.com",
};

const useStyles = makeStyles((theme) => ({
    root: {
        // height: "80%",

        marginTop: 40,
        // maxHeight: "90%",
        // marginLeft: "15%",
        width: "80%",
        maxWidth: 900,
        borderRadius: 5,
        boxShadow: "0px 3px 15px #BCB0B0",
        background: " #EEEEEE",
        display: "flex",
        justifyContent: "space-evenly",
    },
    textFieldBox: {
        display: "flex",
        flexDirection: "column",
        fontFamily: "Roboto-Bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#272782",
        width: "35%",
        marginBottom: "25px",
    },
    textFieldClPmsa: {
        display: "flex",
        flexDirection: "row",
        fontFamily: "Roboto-Bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#272782",
        width: "35%",
        justifyContent: "space-between",
        marginBottom: "25px",
    },
    textFieldClPmsb: {
        display: "flex",
        flexDirection: "column",
        fontFamily: "Roboto-Bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#272782",
        width: "35%",
        marginBottom: "25px",
    },
    rowContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
    },
    title: {
        display: "flex",
        alignItems: "center",
        color: "#272782",
        fontWeight: "400",
        height: "45px",
        left: "702px",
        top: "340px",
        fontFamily: "Roboto-Medium",
        fontStyle: "normal",
        fontSize: "36px",
        lineHeight: "42px",
    },

    [theme.breakpoints.down("md")]: {
        root: {
            height: "70%",
            marginTop: 10,
            maxHeight: 650,
            marginLeft: "0%",
            width: "100%",
            maxWidth: 900,
            borderRadius: 5,
            boxShadow: "0px 3px 15px #BCB0B0",
            background: " #EEEEEE",
            display: "flex",
            justifyContent: "space-evenly",
        },
    },

    [theme.breakpoints.down("xs")]: {
        root: {
            height: "80%",
            marginTop: 10,
            maxHeight: 650,
            marginLeft: "5%",
            width: "90%",
            maxWidth: 900,
            borderRadius: 5,
            boxShadow: "0px 3px 15px #BCB0B0",
            background: " #EEEEEE",
            display: "flex",
            justifyContent: "space-evenly",
        },
        rowContainer: {
            display: "flex",
            flexDirection: "column",
            // justifyContent: "space-around",
            alignItems: "center",
            width: "100%",
        },
        textFieldBox: {
            display: "flex",
            flexDirection: "column",
            fontFamily: "Roboto-Bold",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#272782",
            width: "75%",
            marginBottom: "25px",
        },
    },
}));

let styles = {
    title: {
        display: "flex",
        alignItems: "center",
        color: "#272782",
        fontWeight: "400",
        height: "45px",
        left: "702px",
        top: "340px",
        fontFamily: "Roboto-Medium",
        fontStyle: "normal",
        fontSize: "36px",
        lineHeight: "42px",
    },
};
const theme = createTheme();

const reportTypeMapping = {
    "Alert Processing": "Alert Processing",
    "CMM": "CMM"
};

const internalReportTypeMapping = {
    "Alert Processing": "Alert Processing",
    "CMM": "CMM"
};


const AMCReg = ({ handleSubmit, handleUpdate, userDetails }) => {
    const initialState = userDetails ? {
        pmsName: userDetails?.pmsName,
        pmsCode: userDetails?.pmsCode,
        divisionName: userDetails?.divisionName,
        reportType: userDetails?.reportType,
        // principalName: userDetails?.principalName,
        apmiindiaMailId: userDetails?.user.email,
        // complianceOfficerName: userDetails?.complianceOfficerName,
        // complianceOfficerMailId: userDetails.user.email,
        password: userDetails.user.password,
        userType: "PMS",
        accountStatus: "Active"
    } : {
        pmsName: "",
        pmsCode: "",
        divisionName: "",
        reportType: ["Alert Processing", "CMM"],
        // principalName: "",
        apmiindiaMailId: "",
        // complianceOfficerName: "",
        // complianceOfficerMailId: "",
        password: "",
        userType: "PMS",
        accountStatus: "Active"
    };

    const [input, setInput] = useState(initialState);
    const [loader, setLoader] = useState(false);
    const [selectedReport, setSelectedReport] = useState([]);
    const [open, setOpen] = useState(false);

    let navigate = useNavigate();

    // useEffect(() => {
    //     (async () => {
    //         let authenticated = await checkAuth();
    //         if (!authenticated) navigate("/Login");
    //     })();
    // }, []);

    function handleChange(event) {
        const { name, value } = event.target;
        setInput((prevInput) => ({
            ...prevInput,
            [name]: name.toLowerCase().includes("mailid") ? value.toLowerCase() : value,
        }));
    }


    function validateFields(login) {
        let validEmail = validators.validateEmail(login.apmiindiaMailId).isValid

        // let validPassword = validators.validatePassword(login.user.password) &&
        //     validators.validatePassword(login.coDetails.password) &&
        //     validators.validatePassword(login.ceoDetails.password) &&
        //     validators.validatePassword(login.trusteeDetails.password);;
        // let validPhone = validators.validatePhoneNumber(login.mobile);
        // let validUser = validators.validateUserType(
        //     login.userType,
        //     domains,
        //     login.email
        // );

        if (!validEmail) swal("", "Invalid Email", "warning");
        // else if (!validPassword.isValid) swal("", validPassword.message, "warning");

        // else if (!validPhone.isValid) swal("", validPhone.message, "warning");
        // else if (!validUser.isValid) swal("", validUser.message, "warning");

        return (
            validEmail
            // validPassword.isValid
            // validPhone.isValid &&
            // validUser.isValid
        );
    }

    const autoSelectUser = () => {
        const domain = input.email.split("@")[1];
        let user = "";

        if (domain === domains.SEBIUSER) user = "SEBIUSER";
        else if (domain === domains.KFIN || domain === domains.CAMS) user = "RTA";
        else user = "PMS";

        setInput((prevInput) => ({
            ...prevInput,
            userType: user,
        }));
    };

    const cardStyles = useStyles(theme);
    const ls = new SecureLS()
    let pmsdata = ls.get("pmsdata");
    let pmsList = pmsdata[0].entity
    const pmsArray = pmsList.map(obj => obj.PMS);
    console.log("PMS LIST>>", pmsArray);


    return (
        <Card className={cardStyles.root} >
            <Box sx={{ marginY: "20px", width: "100%", height: "auto" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Box>
                        <Typography component="h1" variant="h4" sx={styles.title}>
                            {userDetails ? "Update PMS Details" : "PMS Registration"}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            width: "90%",
                            height: "2px",
                            backgroundColor: "#272782",
                            marginTop: "10px",
                            marginBottom: "40px",
                        }}
                    />
                </Box>
                <Box component="form" className="noScroll" onSubmit={handleSubmit} sx={{
                    height: {
                        md: "50%",
                        lg: "56%",
                        xl: "59%",
                        xs: "44%",
                        sm: "57%"
                    }, overflow: "scroll"
                }}>
                    <Box className={cardStyles.rowContainer}>
                        <Box className={cardStyles.textFieldBox}>
                            <Box >
                                <p style={{ margin: "0px" }}>PMS Code</p>
                                <TextField
                                    sx={{ width: "100%" }}
                                    variant="standard"
                                    name="pmsCode"
                                    type="text"
                                    disabled={userDetails ? true : false}
                                    placeholder="Enter INP00****"
                                    value={input.pmsCode}
                                    onChange={handleChange}
                                    required
                                />
                                {/* <Autocomplete
                                value={userDetails?.pmsName}
                                options={pmsArray}
                                onChange={(event,newValue)=>{
                                    setInput({
                                        ...input,
                                        pmsName: newValue
                                    })
                                }}
                                disabled = {userDetails ? true : false}
                                clearOnEscape
                                renderInput={(params) => (
                                    <TextField {...params}  placeholder="Select or Search PMS Name"  variant="standard" />
                                )}
                            /> */}
                            </Box>

                        </Box>
                        <Box className={cardStyles.textFieldBox}>
                            <Box >
                                <p style={{ margin: "0px" }}>PMS Name</p>
                                <TextField
                                    sx={{ width: "100%" }}
                                    variant="standard"
                                    name="pmsName"
                                    type="text"
                                    disabled={userDetails ? true : false}
                                    placeholder="Enter PMS Name"
                                    value={input.pmsName}
                                    onChange={handleChange}
                                    required
                                />
                                {/* <Autocomplete
                                value={userDetails?.pmsName}
                                options={pmsArray}
                                onChange={(event,newValue)=>{
                                    setInput({
                                        ...input,
                                        pmsName: newValue
                                    })
                                }}
                                disabled = {userDetails ? true : false}
                                clearOnEscape
                                renderInput={(params) => (
                                    <TextField {...params}  placeholder="Select or Search PMS Name"  variant="standard" />
                                )}
                            /> */}
                            </Box>
                        </Box>

                        {/* <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>DIVISION NAME</p>
                            <FormControl
                                variant="standard"
                                sx={{ my: 0, width: "100%", minWidth: 120 }}
                            >
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    name="divisionName"
                                    value={input.divisionName}
                                    onChange={handleChange}
                                    label="User Type"
                                    placeholder="Select user type"
                                >
                                    <MenuItem value="SEC-1">SEC-1</MenuItem>
                                    <MenuItem value="SEC-2">SEC-2</MenuItem>
                                    <MenuItem value="SEC-3">SEC-3</MenuItem>
                                    <MenuItem value="SEC-4">SEC-4</MenuItem>
                                    <MenuItem value="SEC-5">SEC-5</MenuItem>


                                </Select>
                            </FormControl>
                        </Box> */}


                    </Box>

                    <Box className={cardStyles.rowContainer}>
                        {/* <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>Principal Officer Name</p>
                            <TextField
                                variant="standard"
                                name="principalName"
                                type="text"
                                placeholder="Enter Principal name"
                                value={input.principalName}
                                onChange={handleChange}
                                required
                            />
                            <div id="error-CEOName"></div>
                        </Box> */}
                        <Box className={cardStyles.textFieldClPmsb}>
                            <p style={{ margin: "0px" }}>Report Name</p>
                            <FormControl
                                variant="standard"
                                sx={{ my: 0, width: "100%", minWidth: 120 }}
                            >
                                <Select
                                    name="reportType"
                                    multiple
                                    value={input.reportType}
                                    onChange={(event) => {
                                        const selectedValues = event.target.value.map(value => internalReportTypeMapping[value] || value);
                                        handleChange({ target: { name: 'reportType', value: selectedValues } });
                                    }}
                                    label="Report Type"
                                    placeholder="Select Report Type"
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    renderValue={(selected) => selected.map(value => reportTypeMapping[value] || value).join(', ')}
                                    variant="standard"
                                >
                                    {Object.keys(reportTypeMapping).map((name) => (
                                        <MenuItem key={name} value={name}>
                                            <Checkbox checked={input.reportType.indexOf(internalReportTypeMapping[name] || name) > -1} />
                                            <ListItemText primary={reportTypeMapping[name]} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Box>
                        <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>APMI Registered ID</p>
                            <TextField
                                variant="standard"
                                name="apmiindiaMailId"
                                type="mail"
                                placeholder="Enter APMI registered mail ID"
                                value={input.apmiindiaMailId}
                                onChange={handleChange}
                                required
                            />
                            <div id="error-CEOMail"></div>
                        </Box>



                    </Box>
                    {/* <Box className={cardStyles.rowContainer}>
                        <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>Compliance Officer Name</p>
                            <TextField
                                variant="standard"
                                name="complianceOfficerName"
                                type="text"
                                placeholder="Enter Compliance Officer Name"
                                value={input.complianceOfficerName}
                                onChange={handleChange}
                                required
                            />
                            <div id="error-mobile-number"></div>
                        </Box>
                        <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>Compliance Officer Mail id</p>
                            <FormControl
                                variant="standard"
                                sx={{ my: 0, width: "100%", minWidth: 120 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="complianceOfficerMailId"
                                    type="mail"
                                    placeholder="Enter Compliance Officer Mail ID"
                                    value={input.complianceOfficerMailId}
                                    onChange={handleChange}
                                    required
                                />
                            </FormControl>
                        </Box>
                    </Box> */}

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >

                    </Box>

                </Box>
                {userDetails ?
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            type="submit"
                            variant="contained"
                            onClick={() => {
                                if (validateFields(input)) {
                                    // console.log("Final Input>>",input);
                                    handleUpdate({
                                        pmsName: input.pmsName,
                                        pmsCode: input.pmsCode,
                                        divisionName: input.divisionName,
                                        reportType: input.reportType,
                                        principalName: input.principalName,
                                        // complianceOfficerName: input.complianceOfficerName,
                                        user: { email: input.apmiindiaMailId, password: userDetails.user.password },
                                        // user: { email: input.complianceOfficerMailId, password: userDetails.user.password },
                                        userType: "PMS",
                                        accountStatus: "Active"
                                    })
                                }
                            }}
                            sx={{
                                bgcolor: "#272782",

                                width: "150px",
                                borderRadius: "5px 5px 5px 5px",
                                height: 40,
                                fontFamily: "Roboto-Light",
                                fontSize: "18px",
                                lineHeight: "23px",
                                display: "flex",
                                align: "center",
                                color: "#FFFFFF",
                                margin: "0rem 0.5rem 0rem 0rem"
                            }}
                        >
                            <span
                                style={{
                                    padding: "0 0 0 0",
                                    fontSize: 14,
                                    fontWeight: 600,
                                }}
                            >
                                Update{"   "}
                            </span>
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            onClick={() => {
                                setOpen(true)
                            }}
                            sx={{
                                bgcolor: "#272782",
                                mt: 1,
                                width: "px",
                                borderRadius: "5px 5px 5px 5px",
                                height: 40,
                                fontFamily: "Roboto-Light",
                                fontSize: "18px",
                                lineHeight: "23px",
                                display: "flex",
                                align: "center",
                                color: "#FFFFFF",
                                margin: "0rem 0rem 0rem 0.5rem"
                            }}
                        >
                            <span
                                style={{
                                    padding: "0 0 0 0",
                                    fontSize: 14,
                                    fontWeight: 600,
                                }}
                            >
                                Reset Password{"   "}
                            </span>
                        </Button>
                    </div> :
                    <div style={{ display: "flex", justifyContent: "center !imprtant" }}>
                        <Button
                            type="submit"
                            variant="contained"
                            onClick={() => {
                                if (validateFields(input)) {
                                    handleSubmit(input)
                                    setInput(initialState)
                                }
                            }}
                            sx={{
                                bgcolor: "#272782",
                                mt: 1,
                                width: "150px",
                                borderRadius: "5px 5px 5px 5px",
                                height: 40,
                                fontFamily: "Roboto-Light",
                                fontSize: "18px",
                                lineHeight: "23px",
                                display: "flex",
                                align: "center",
                                color: "#FFFFFF",
                                margin: "5px auto"
                            }}
                        >
                            <span
                                style={{
                                    padding: "0 0 0 0",
                                    fontSize: 14,
                                    fontWeight: 600,
                                }}
                            >
                                Register{"   "}
                            </span>
                        </Button>
                    </div>
                }
            </Box>
            {open && <EmailResetModal open={open} setOpen={setOpen} />}
        </Card >
    )
}

export default AMCReg